<template>
    <div class="t_content_view">
        <el-page-header @back="goBack" content="活码页面样式" />
        <div class="t_add_title">
            活码页面样式
        </div>
        <div class="t_scstyle_box">
            <el-form label-width="120px">
                <el-form-item label="一级主题：">
                    <el-input style="width:500px" placeholder="请输入一级主题" v-model="form.titleOne"  clearable />
                </el-form-item>
                <el-form-item label="企业logo：">
                    <el-upload class="avatar-uploader"  
                    :action="upload_img"
                    :headers= 'headers'
                    accept="image/jpg,image/jpeg,image/png"
                    :show-file-list="false"
                    :on-success="web_handleAvatarSuccess"
                    :before-upload="web_beforeAvatarUpload"    >
                        <img v-if="form.logoAddr" :src="form.logoAddr" class="avatar" />
                        <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
                    </el-upload>
                </el-form-item>
                <div class="t_img_tips">建议尺寸：100px*100px;支持jpg、jpeg、png格式，图片大小不超过2MB</div>
                <el-form-item label="二级主题：">
                    <el-input style="width:500px" placeholder="请输入二级主题" v-model="form.titleTwo"  clearable />
                </el-form-item>
                <el-form-item label="三级主题：">
                    <el-input style="width:500px" placeholder="请输入三级主题" v-model="form.titleThree"  clearable />
                </el-form-item>
                <el-form-item  label="头像：">
                    <el-upload class="avatar-uploader" :action="upload_img"
                                :headers= 'headers'
                                accept="image/jpg,image/jpeg,image/png"
                                :show-file-list="false"
                                :on-success="web_handleAvatarSuccess2"
                                :before-upload="web_beforeAvatarUpload" >
                        <img v-if="form.headrAddr" :src="form.headrAddr" class="avatar" />
                        <el-icon v-else class="avatar-uploader-icon">
                            <Plus />
                        </el-icon>
                    </el-upload>
                    
                </el-form-item>
                <div class="t_img_tips" >建议尺寸：100px*100px;支持jpg、jpeg、png格式，图片大小不超过2MB</div>
                <el-form-item label="引导文案：">
                    <el-input style="width:500px" placeholder="请输入引导文案" v-model="form.leadingContent"  clearable />
                </el-form-item>
                <el-form-item label="备注文案：">
                    <el-input style="width:500px" placeholder="请输入备注文案" v-model="form.infoContent"  clearable />
                </el-form-item>
            </el-form>
            <div class="t_scexample">
                <div id="content">
                    <img v-if="form.logoAddr" class="t_ewm_logo" :src="form.logoAddr" alt="">
                    <div class="t_titleone">{{ form.titleOne }}</div>
                    <div class="t_titletwo">{{form.titleTwo}}</div>
                    <div class="t_titletwo">{{form.titleThree}}</div>
                    <div class="t_ewm_box">
                        <img class="t_ewm_ewm" :src="ewm" alt="">
                        <img v-if="form.headrAddr"  class="t_ewm_head" :src="form.headrAddr" alt="">
                    </div>
                    <div class="t_ewm_info" >{{ form.leadingContent }}</div>
                    <div class="t_ewm_info" >{{ form.infoContent }}</div>
                </div>
                <img style="width:100%" src="../assets/img/schm.png" alt="">
                <el-button @click="saveimg" style="margin-top:10px" color="#4F46E5"  type="primary">下载</el-button>
            </div>
        </div>
        <div style="margin-top:20px">
            <el-button color="#4F46E5" @click="addhm" type="primary">确定</el-button>
            <el-button @click="resthm">取消</el-button>
        </div>
    </div>

</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch,inject } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage,ElMessageBox } from 'element-plus'
import { Plus } from '@element-plus/icons-vue'
import { qdmlist,addqdhm,detailqdhm,changeqdhm } from '@/assets/js/common.js'
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
const goBack = () => {
    router.push({ path: '/navtkyl/ewmlist' })
}
//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    console.log(route.query.id)
    changeinfo()
})

const form = reactive({
    titleOne:'',
    logoAddr:'',
    titleTwo:'',
    titleThree:'',
    headrAddr:'',
    leadingContent:'',
    infoContent:''
})
const ewm = ref('')
//网页缩略图
//上传图片地址
const upload_img = ref(_url2+'/work/tblTimetask/fileUpload')
const headers = {
  'Authorization': 'Bearer ' + $cookies.get("fanstoken")
}



//上传成功
const web_handleAvatarSuccess = (response,uploadFile)=>{
    form.logoAddr = response.result.url
}
const web_handleAvatarSuccess2 = (response,uploadFile)=>{
    form.headrAddr = response.result.url
}
//上传前检测
const web_beforeAvatarUpload = (rawFile)=>{
    if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('上传图片大小不能超过2MB!')
        return false
    }
    return true
}
const changeinfo = ()=>{
    detailqdhm(_url2,{id:route.query.id}).then((response)=>{
        if (response.data.msg.code == 0) {
            console.log(response.data.result)
            form.titleOne = response.data.result.titleOne
            form.logoAddr = response.data.result.logoAddr
            form.titleTwo = response.data.result.titleTwo
            form.titleThree = response.data.result.titleThree
            form.headrAddr = response.data.result.headrAddr
            form.leadingContent = response.data.result.leadingContent
            form.infoContent = response.data.result.infoContent
            ewm.value = response.data.result.qrAddr

        }
    })
}


//确定提交
const addhm = ()=>{
    console.log(form)
    
    ElMessageBox.confirm(
    '是否确认提交?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        //判断是新增还是编辑
        changeqdhm(_url2,{
            id:route.query.id,
            titleOne:form.titleOne,
            logoAddr:form.logoAddr,
            titleTwo:form.titleTwo,
            titleThree:form.titleThree,
            headrAddr:form.headrAddr,
            leadingContent:form.leadingContent,
            infoContent:form.infoContent,
            
        }).then((response)=>{
            if (response.data.msg.code == 0) {
                ElMessage({
                    type: 'success',
                    message: '修改成功！',
                })
                router.push({ path: '/navtkyl/ewmlist' })
            }
        })
        
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}
//取消
const resthm = ()=>{
    router.push({ path: '/navtkyl/ewmlist' })
}
//保存成图片
const saveimg = ()=>{
    const element = document.getElementById('content');
    html2canvas(element,{
        useCORS: true, // 这个选项会自动处理跨域问题
        scale: 10,//图片清晰度，越高越清楚，图片质量越大 
        backgroundColor: null,//画出来的图片有白色的边框,不要可设置背景为透明色（null）
    }).then(canvas => {
    
        // 创建一个图像元素
        // var img = new Image();
        // img.src = canvas.toDataURL('image/png');
        // 将图像添加到DOM中
        // document.body.appendChild(img);
        //下载
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.href = canvas.toDataURL('image/png');
        a.download = "";
        a.click();
    });
}
</script>
<style scoped>

/* .t_content_view {
    padding: 20px;
} */



.t_scexample {
    width: 300px;
    margin-left: 30px;
    text-align: center;
    position: relative;
}

.t_scstyle_box {
    display: flex;
    /* background-color: #F1F3F9; */
    padding: 20px;
}
.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

:deep(ww-open-data iframe){
    width: 100px !important;
    height: 20px !important;
}

</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 29px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
.t_img_tips{
    color:#606266;
    font-size: 15px;
    margin-left: 120px;
    margin-bottom: 10px;
}
#content{
    width: 270px;
    background-color: blue;
    border-radius: 10px;
    text-align: center;
    box-sizing: border-box;
    padding: 20px;
    background-image: linear-gradient(to bottom,#4eb3e9   0%, #aededb   50%, #dbf9fe 100%);
    position: absolute;
    top: 90px;
    left: 15px;
}
.t_ewm_logo{
    width: 40px;
    height: 40px;
    border-radius: 50%;
   
}
.t_ewm_box{
    background-color: white;
    border-radius: 10px;
    width:100%;
    box-sizing: border-box;
    padding: 15px;
    position: relative;
    margin-top: 10px;
    margin-bottom: 10px;
}
.t_ewm_ewm{
    width: 100%;
}
.t_ewm_head{
    width: 37px;
    height: 37px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -9%;
    margin-left: -8%;

}
.t_titleone{
    font-size:27px;
    color: white; 
    margin-bottom: 10px;
    margin-top: 10px;
    font-family: 'titlefont';
}
.t_titletwo{
    font-size:13px;
    color: white;
    margin-bottom: 3px;
}
.t_ewm_info{
    font-size:13px;
    
}
@font-face{
	font-family:'titlefont';
	src:url( '../assets/img/title.ttf' ) 
}
</style>